import * as React from "react";

function SvgCurve3(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1600 200" {...props}><path className="curve-3_svg__st1" d="M-6.7 13.4S456 171.1 876.1 171.1 1606.4 16 1606.4 16v192.6H-6.7V13.4z" /></svg>;
}

export default SvgCurve3;